import { useState } from "react";
import api from "../../Utils/api";

import {
  accessMap,
  employmentTypes,
  stressProfileMap,
} from "../../Utils/const";

export default function EmploymentDetails({
  userID,
  deputyAccessLevel,
  primaryLocation,
  employmentType,
  payRates,
  workPeriod,
  stressProfile,
  hoursPerPeriod,
  leaveEntitlements,
}) {
  const [openPayratesDialog, setOpenPayratesDialog] = useState(false);

  return (
    <div className="p-6">
      {/* Work Details Card */}
      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Work Details
        </h2>
        <hr className="w-full mb-2 mt-2" />

        <div className="space-y-3 px-4 text-sm text-gray-800">
          <div className="flex justify-between">
            <span>Deputy Access Level</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full">
              {accessMap[deputyAccessLevel]}
            </span>
          </div>
          <div className="flex justify-between">
            <span>Works at</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full">
              {primaryLocation}
            </span>
          </div>
        </div>
      </section>
      {/* Pay Details Card */}
      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Pay Details
        </h2>
        <hr className="w-full mb-2 mt-2" />

        <div className="space-y-3 bg-gray-100 p-4 rounded-md text-sm text-gray-800">
          <div className="flex justify-between items-center"></div>
          <div>
            <div className="my-2">Employment Type</div>

            <div className="font-semibold bg-red-50 p-1 border border-red-100 rounded-sm w-fit text-red-600 mb-2">
              {employmentTypes[employmentType]}
            </div>
            <div className="my-4">Pay rate (Default)</div>
            {renderPayRates(employmentType, payRates)}
          </div>
        </div>
      </section>

      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Regular working hours
        </h2>
        <hr className="w-full mb-2 mt-2" />

        <div className="space-y-3 px-4 text-sm text-gray-800">
          <div className="flex justify-between">
            <span>Work period</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full">
              {workPeriod.day}, {workPeriod.period}
            </span>
          </div>
          <div className="flex justify-between">
            <span>Hours per period</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full">
              {hoursPerPeriod}
            </span>
          </div>

          <div className="flex justify-between">
            <span>Stress profile</span>
            <span className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full">
              {stressProfileMap[stressProfile]}
            </span>
          </div>
        </div>
      </section>

      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Leave Entitlements
        </h2>
        <hr className="w-full mb-2 mt-2" />

        <div className="space-y-1 px-4 text-sm text-gray-800">
          {leaveEntitlements.map((leave) => (
            <div
              key={leave.id}
              className="flex items-center justify-between px-3 py-2 bg-gray-50 border border-gray-200 rounded"
            >
              <span className="text-gray-800 text-sm">{leave.name}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function renderPayRates(employmentType, payRates) {
  // If payRates is missing, show nothing
  if (!payRates) return null;

  // Fixed Rate
  if (payRates.payRateType === "fixed_rate") {
    return (
      <div>
        <div>
          <span className="font-medium my-2">Fixed Rate:</span> €
          {payRates.fixedRate}
        </div>
        {payRates.salaryAmount && (
          <div>
            <span className="font-medium my-2">Annual Salary:</span> €
            {payRates.salaryAmount}
          </div>
        )}
      </div>
    );
  }

  // Salary
  if (payRates.payRateType === "salary") {
    return (
      <div>
        <div>
          <span className="font-medium my-2">Salary:</span> €
          {payRates.salaryAmount} ({payRates.salaryPeriod})
        </div>
      </div>
    );
  }

  // Hourly or similar
  return (
    <div>
      <div className="my-2">
        <span className="font-medium my-2">Weekday:</span> €{payRates.weekday}
      </div>
      <div className="my-2">
        <span className="font-medium my-2">Saturday:</span> €{payRates.saturday}
      </div>
      <div className="my-2">
        <span className="font-medium my-2">Sunday:</span> €{payRates.sunday}
      </div>
      <div className="my-2">
        <span className="font-medium my-2">Public Holiday:</span> €
        {payRates.publicHoliday}
      </div>
    </div>
  );
}
